import { render, staticRenderFns } from "./schoolInfoPath.vue?vue&type=template&id=ef4356e8&scoped=true"
import script from "./schoolInfoPath.vue?vue&type=script&lang=js"
export * from "./schoolInfoPath.vue?vue&type=script&lang=js"
import style0 from "./schoolInfoPath.vue?vue&type=style&index=0&id=ef4356e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4356e8",
  null
  
)

export default component.exports